export const formatSize = (sizeInBytes: number): [string, boolean] => {
	if (sizeInBytes === undefined) {
		return ['-', false];
	}

	const kilobyteSize: number = sizeInBytes / 1024;
	const megabyteSize: number = kilobyteSize / 1024;

	if (megabyteSize >= 1) {
		return [`${megabyteSize.toFixed(2)} MB`, true];
	}

	const size: string = `${kilobyteSize.toFixed(2)} KB`;
	return [size, kilobyteSize > 100];
};
